import React from 'react'
export const ProhibitedNotice = ({ backHref }: { backHref?: string }): JSX.Element => (
  <div className="text-center pb-6">
    <h4 className="mb-3">{i18n.t('donate.prohibited_headline')}</h4>
    <div className="mb-6">{i18n.t('donate.prohibited_notice')}</div>
    {backHref && (
      <a className="btn btn-primary btn-large" href={backHref}>
        {i18n.t('donate.prohibited_call_to_action')}
      </a>
    )}
  </div>
)
